import { Box, styled } from '@withjoy/joykit';

export const HoverButtonContainer = styled(Box)`
  position: relative;

  &:hover {
    button {
      visibility: visible;
    }
  }
`;
